import { render } from "./Spinner.vue?vue&type=template&id=675ae58a&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=675ae58a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675ae58a"]])

export default __exports__